import { Link } from "@inertiajs/react"

const LEGAL_LINKS = [
  { href: "/mentions-legales", label: "Mentions légales" },
  { href: "/confidentiality", label: "Confidentialité" },
  { href: "/cgv", label: "CGV" },
  { href: "/cookies", label: "Cookies" },
]

const SERVICE_LINKS = [
  { href: "/#services", label: "Services" },
  { href: "/#products", label: "Produits" },
  { href: "/#clients", label: "Clients" },
  { href: "/#contact", label: "Contact" },
]

export default function Footer() {
  const year = new Date().getFullYear()

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith("#")) {
      e.preventDefault()
      const target = document.querySelector(href)
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    }
  }

  return (
    <footer className="bg-[#06060f] border-t border-white/5 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <span className="text-xl font-bold text-white">Chalky</span>
            <p className="mt-3 text-sm text-slate-500 leading-relaxed">
              Agence web à Nantes & Paris. Développement React, Rails et solutions IA.
            </p>
            <div className="mt-4 space-y-1 text-sm text-slate-500">
              <p>hello@chalky.fr</p>
              <p>+33 6 74 23 60 80</p>
              <p>Nantes, France</p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Navigation
            </h4>
            <ul className="space-y-2">
              {SERVICE_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleAnchorClick(e, link.href)}
                    className="text-sm text-slate-500 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Légal
            </h4>
            <ul className="space-y-2">
              {LEGAL_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-slate-500 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            © {year} Chalky. Tous droits réservés.
          </p>
          <p className="text-xs text-slate-600">
            Fait avec <span className="text-violet-400">♥</span> à Nantes
          </p>
        </div>
      </div>
    </footer>
  )
}
